module.exports = __webpack_public_path__ + "img/N110-1-EN.fec1710e.png";